import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { QueryDocument } from '../models/query-document.model';

@Injectable({
  providedIn: 'root'
})
export class FileDocumentQueryService {
  cppUrl = AppConfig.settings.apiUrls.cpp;


  constructor(
    private readonly http: HttpClient,
  ) {}

  /**
   * Obtener historial de mensajes/consultas de un documento
   */
  getQueryData(docId: number, queryTypeID: number): Observable<QueryDocument[]> {
    return this.http.get<QueryDocument[]>(`${this.cppUrl}/DocMessages/ByDocument/${docId}/${queryTypeID}`);
  }

  // Crear una nueva consulta inicial
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  postQuery(payload: QueryDocument): Observable<any> {
    return this.http.post<QueryDocument>(`${this.cppUrl}/DocMessages`, payload)
  }

  /**
   * Enviar una respuesta (En este caso, parece que reutilizas el POST de DocMessageDTO)
   */
  postReply(reply: QueryDocument): Observable<QueryDocument> {
    return this.postQuery(reply);
  }

  /**
   * Borrar un mensaje específico
   */
  deleteMessage(msgId: string): Observable<void> {
    return this.http.delete<void>(`${this.cppUrl}/DocMessages/${msgId}`);
  }

  /**
   * Cerrar una consulta específica
   * @param docID
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  closeQuery(docID: string | number): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.http.put<any>(`${this.cppUrl}/DocMessages/${docID}/close`, {});
  }
}
